import { EmployeeParentalLeaves } from './EmployeeParentalLeaves';
import { hrEmpEmergencyContactDtl } from './hrEmpEmergencyContactDtl';
import { HrEmpFamilyDetail } from './hrEmpFamilyDetail';
import { ProfileVerificationStatus } from './ProfileVerificationStatus';

export class hrEmpPersonalDetails {
  EmpCode : number
  NoOfDependents: number;
  MaritalStatus: number;
  WeddingDate: Date;
  CreatedBy: string;
  CreatedDate: Date;
  ModifiedBy: string;
  ModifiedDate: Date;
  emergencyContactDtls: hrEmpEmergencyContactDtl[];
  parentalLeaves: EmployeeParentalLeaves[];
  Father: HrEmpFamilyDetail = new HrEmpFamilyDetail();
  Mother: HrEmpFamilyDetail = new HrEmpFamilyDetail();
  Spouse: HrEmpFamilyDetail = new HrEmpFamilyDetail();
  children: HrEmpFamilyDetail[] = [];
  FamilyDetails: HrEmpFamilyDetail[] = [];
  profileVerification: ProfileVerificationStatus = new ProfileVerificationStatus();
  twoTabProfile: boolean;
}
